define('models/WidgetCollectionCollection',['underscore','ObjectCollection','LocalStorage','models/WidgetCollectionModel'],function (_,ObjectCollection,LocalStorage,WidgetCollectionModel) {
    //
    // Collection WidgetCollection
    //
    var WidgetCollectionCollectionPrototype = {
        
        name:'WidgetCollectionCollection',
        route:'apiWidgetCollectionCollection',
        model:WidgetCollectionModel,
        
        initialize:function(){
            // ObjectCollection constructor heritage
            ObjectCollection.prototype.initialize.apply(this,arguments);
            //
        },
    };

    var WidgetCollectionCollection = ObjectCollection.extend(WidgetCollectionCollectionPrototype);

    return WidgetCollectionCollection;
});
